export default {
  defaultStore: 'ajio',
  luxeStore: 'luxe',
  landing: {
    screenType: 'landing screen',
    screenName: 'landing screen'
  },
  search: {
    screenType: 'search screen',
    screenName: 'search screen'
  },
  wishlist: {
    screenType: 'closet screen',
    screenName: 'closet screen'
  },
  coupon: {
    screenType: 'coupon screen',
    screenName: 'coupon screen'
  },
  orderConfirmation: {
    screenType: 'order confirmation screen',
    screenName: 'order confirmation screen'
  },
  shipping: {
    screenType: 'shipping screen',
    screenName: 'shipping screen'
  },
  addressSelection: {
    screenType: 'address management screen',
    screenName: 'address list screen - shipping'
  },
  addressSelectionMyAccount: {
    screenType: 'address management screen',
    screenName: 'address list screen - address'
  },
  manageAddressMyAccount: {
    screenType: 'address management screen',
    screenName: 'address screen - address'
  },
  manageAddress: {
    screenType: 'shipping screen',
    screenName: 'address screen - shipping'
  },
  shippingStorePickUp: {
    screenType: 'shipping screen',
    screenName: 'store pickup'
  },
  plp: {
    screenType: 'plp screen',
    screenName: 'plp screen'
  },
  cart: {
    screenType: 'bag screen',
    screenName: 'bag screen'
  },
  navigation: {
    screenType: 'navigation screen',
    screenName: 'hamburger navigation screen'
  },
  brands: {
    screenType: 'brands screen',
    screenName: 'brands screen'
  },
  hp: {
    screenType: 'home screen',
    screenName: 'home screen'
  },
  myAccount: {
    screenType: 'my account screen',
    screenName: 'my account screen'
  },
  pdp: {
    screenType: 'pdp screen',
    screenName: 'pdp screen'
  },
  sizeGuide: {
    screenName: 'size guide',
    screenType: 'size guide'
  },
  login: {
    pageType: 'user account screen',
    pageName: 'login screen'
  },
  signup: {
    pageType: 'user account screen',
    pageName: 'signup screen'
  },
  pdpList: {
    similarList: 'pdp screen - similar product widget',
    recentlyList: 'pdp screen - recently viewed widget',
    youMayAlsoLikeList: 'pdp screen - you may also like'
  },
  landingList: {
    widgetList: 'landing screen - product widget'
  },
  similarTo: {
    widgetName: 'similar products widget'
  },
  panCardCollection : {
    screenName: 'PAN verification screen',
    screenType: 'PAN verification screen'
  }
};
